import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export var processProfile = function processProfile(profile) {
  var id = profile.id,
    displayName = profile.displayName,
    alias = profile.alias,
    icon = profile.icon,
    subtype = profile.subtype,
    tagline = profile.tagline,
    description = profile.description,
    _profile$organization = profile.organizations,
    organizations = _profile$organization === void 0 ? [] : _profile$organization,
    certifications = profile.certifications;
  var roleAdviser = organizations ? organizations.find(function (organization) {
    return organization.roles.includes('adviser');
  }) : null;
  var adviser = Boolean(roleAdviser);
  var isCompany = subtype === 'company';
  var isPro = isCompany || adviser;
  return {
    id: id,
    subtype: subtype,
    name: displayName,
    alias: alias,
    icon: icon,
    features: subtype === 'user' ? profile.features || [] : [],
    tagline: isCompany ? description : tagline,
    company: adviser ? {
      name: roleAdviser.displayName,
      alias: roleAdviser.alias,
      features: {
        blog: roleAdviser.features.blog
      },
      hasBlog: roleAdviser.features.blog && !roleAdviser.private
    } : null,
    adviser: adviser,
    verified: isPro,
    organizations: organizations,
    aditionalIcon: !isPro && certifications && certifications.length ? {
      name: certifications[0].organization,
      icon: "/image/".concat(certifications[0].icon),
      url: "/grupos/".concat(certifications[0].alias)
    } : null
  };
};